import React, { Component, Fragment } from "react";

export default class Report extends Component {
  state = { report: {} };

  componentDidMount() {
    this.setState({ report: this.props.report });
  }

  render() {
    return (
      <div className="tile is-child box notification">
        <Fragment>
          <button
            onClick={(event) => {
              this.props.handleDeleteReport(this.props.report.id, event);
            }}
            className="delete"
          ></button>
        </Fragment>
        <div>
          <p className="product-title">
            Anmeldt brugernavn: {this.props.report.reportedUserName}
          </p>
          <p className="product-id">
            Anmeldt bruger id: {this.props.report.reportedUserId}
          </p>
          <p className="product-id">
            Anmelder bruger id:{this.props.report.userId}
          </p>
          <p className="product-id">id: {this.props.report.id}</p>
        </div>
      </div>
    );
  }
}
